import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {
  HouseholdSummaryResponse,
  CommonUtility,
  HouseholdSummaryRequest,
  HouseHoldSummary,
  AgGridUtility, DOUBLE_ROW_HEADER, DateUtility
} from '../shared';

import { ServerConstantsService} from '../shared';
import {ReferenceTableService} from '../reference-table.service';
import {DataService} from '../shared';
import {NotificationsService} from 'angular2-notifications';
import { GridOptions } from 'ag-grid';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-household-summary',
  templateUrl: './household-summary.component.html',
  styleUrls: ['./household-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class HouseholdSummaryComponent implements OnInit {
  response: HouseholdSummaryResponse;
  request: HouseholdSummaryRequest;
  hhSummaryList: HouseHoldSummary[]=[];
  programArray: any[];
  programMap: any;
  relationshipArray: any[];
  relationshipMap: any;

  serverConstants: any;
  userActionNotificationsMap: any;
  refData: any;

  referralId = '';
  wpPersonId = '';
  noData: Boolean = false;
  error: Boolean = false;

  successMessage: string;

  errorMessage: string;
  sharedData: any;

  workPartStatus: any;
  workPartStatusMap: any;
  otherCharacteristics: any;
  otherCharacteristicsMap: any;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  columnDefs: any;
  context: any;
  relationshipJson: any;
  workPartStatusJson: any;
  otherCharacteristicsJson: any;
  genderCds: Array<any>;
  genderMap: Map<string, string>;
  gridOptions: GridOptions;
  gridApi;
  isUniverse = false;
  clientInfo: HouseHoldSummary;
  ssnValue;

  firstTime: Boolean = true;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private dateUtil: DateUtility,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private datePipe:DatePipe
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('CLINF') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    /* set global values for page */
    this.dataService.globalAccess = false;
    this.getRefTableData();
    this.getColumnDefinitions();
    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.ssnValue = this.sharedData.get('SSN_SEARCH');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');

    this.hhSummaryList = [];
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadFromAries(this.sharedData.get('personProvider').emciId) : this.load();
  }

  getColumnDefinitions() {
    this.context = {
      component: this,
    };

    this.columnDefs = [
      {
        headerName: 'Name',
        colId: "FIRST_NAME&LAST_NAME",
        valueGetter: function getName(params) {
          return `${params.data.FIRST_NAME} ${params.data.LAST_NAME}`;
        },
        tooltip: function getName(params) {
          return `${params.data.FIRST_NAME} ${params.data.LAST_NAME}`;
        },
        suppressFilter: false,
      },
      {
        headerName: 'Relationship',
        field: 'RELATION_TO_WR_INDIVIDUAL',
        //refData: this.relationshipJson,

        cellStyle: {'white-space': 'normal'},
       // valueGetter: this.getRelDesc,
      },
      {
        headerName: 'Gender',
        field: 'GENDER_CD',
        width: 150,
        cellStyle: {'white-space': 'normal'},
       // valueGetter: this.getGenderDesc,
      },
      {
        headerName: 'Date of Birth',
        field: 'DOB_DT',
        width: 150,
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
      },
      {
        headerName: 'Work Participation Status',
        field: 'WORK_PARTICIPATION_CD',
        //refData: this.workPartStatusJson,
        width: 270,
        cellStyle: {'white-space': 'normal'},
       // valueGetter: this.getWorkPartDesc,
      },
      {
        headerName: 'Other Characteristics',
        field: 'OTHER_CHARACTERISTICS',
        width: 270,
        //refData: this.otherCharacteristicsJson,
        autoHeight: true,
        cellStyle: {'white-space': 'normal'},
       // valueGetter: this.getOtherCharDesc,
      },
    ];
  }

  getRelDesc(params){
    const hhSummary: HouseHoldSummary = params.data;
    const that = params.context.component;

    if(hhSummary.RELATION_TO_WR_INDIVIDUAL === null || hhSummary.RELATION_TO_WR_INDIVIDUAL === undefined){
      return '';
    } else {
      return that.relationshipMap.get(hhSummary.RELATION_TO_WR_INDIVIDUAL);
    }
  }

  getWorkPartDesc(params){
    const hhSummary: HouseHoldSummary = params.data;
    const that = params.context.component;

    if(hhSummary.WORK_PARTICIPATION_CD === null || hhSummary.WORK_PARTICIPATION_CD === undefined){
      return '';
    } else {
      return that.workPartStatusMap.get(hhSummary.WORK_PARTICIPATION_CD);
    }
  }

  getOtherCharDesc(params){
    const hhSummary: HouseHoldSummary = params.data;
    const that = params.context.component;
    let value = '';

    if(hhSummary.OTHER_CHARACTERISTICS === null || hhSummary.OTHER_CHARACTERISTICS === undefined){
      return '';
    } else {
      const characteristics = hhSummary.OTHER_CHARACTERISTICS.split(',');

      for(const c of characteristics){
        value += that.otherCharacteristicsMap.get(c) + ', ';
      }
      return value.substr(0, value.length - 2);
      //return that.otherCharacteristicsMap.get(hhSummary.otherCharCd);
    }
  }

  getGenderDesc(params){
    const hhSummary: HouseHoldSummary = params.data;
    const that = params.context.component;

    if(hhSummary.GENDER_CD === null || hhSummary.GENDER_CD === undefined){
      return '';
    } else {
      return that.genderMap.get(hhSummary.GENDER_CD);
    }
  }

  load() {

    this.http.get<HouseHoldSummary[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetHouseholdSummary/' + this.ssnValue).subscribe(
      (data:HouseHoldSummary[]) => {
        if (data !== null && data !== undefined && data.length > 0) {
          this.hhSummaryList = data;
          this.hhSummaryList.forEach(rows =>{
            rows.DOB_DT=this.dateUtil.formatDate( rows.DOB_DT);
          })

        } else {
          this.notificationService.warn('Universe Search', "Household Summary Information not found in Eligibility System");
          this.hhSummaryList = [];
        }
      },
      response => {
        this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });

    // this.http.post<HouseholdSummaryResponse>(this.serverConstants.COMMON_SERVER_API_URL + '/hhsummary/load', request).subscribe(
    //   (data: any) => {
    //     if (data.hasOwnProperty('errorCode')) {
    //       this.notificationService.error('Household Summary', this.userActionNotificationsMap.ERROR);
    //     } else {
    //       if (data != null) {
    //         this.hhSummaryList = data;
    //       } else {
    //         this.hhSummaryList = [];
    //         this.noData = true;
    //       }
    //     }
    //   }, response => {
    //     this.error = true;
    //     this.notificationService.error('Household Summary', this.userActionNotificationsMap.ERROR);
    //   }, () => {
    //     this.error = false;
    //   });
  }

  loadFromAries(emciId) {

    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/householdInfo/' + emciId).subscribe(
      (data: Array<Object>) => {
        if(data["indvId"]){
          let hhList = [];
          data["relation"].forEach((element)=>{
            let record = {
              FIRST_NAME:null,
              LAST_NAME:null,
              RELATION_TO_WR_INDIVIDUAL:null,
              GENDER_CD:null,
              DOB_DT:null,
              WORK_PARTICIPATION_CD:null,
              OTHER_CHARACTERISTICS:null,
            }
            record.FIRST_NAME = element["indvName"];
            record.LAST_NAME = '';
            record.RELATION_TO_WR_INDIVIDUAL = element["relationshipTypeCd"];
            if(element["genderCd"] == 'M'){
              record.GENDER_CD= 'Male';
            }
            else{
              record.GENDER_CD = 'Female';
            }
            let dobDt = new Date(element["dobDt"]);
            if(dobDt != null) { 
              record.DOB_DT= this.datePipe.transform(dobDt, 'yyyy/MM/dd');
            }
            //record.dob = element["HH_MEM_DOB"].split(' ')[0];
            record.WORK_PARTICIPATION_CD = element["wrkParticipationCd"];
            record.OTHER_CHARACTERISTICS = null;
            hhList.push(record);        
          });
          this.hhSummaryList = hhList;
        }
        else {
          this.notificationService.warn('Universe Search', "Household Summary Information not found in Eligibility System");
          this.hhSummaryList = [];
        }
      },
      response => {
        this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });


  }

  getRefTableData() {
    this.programArray = this.data.getValueFromSharedDataMap("PROGRAMS");
    this.programMap = this.commonUtil.createMapFromList(this.programArray);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap("USER-ACTION-NOTIFICATIONS"));

    this.relationshipArray = this.data.getValueFromSharedDataMap("RELATIONSHIP");
    this.relationshipMap = this.commonUtil.createMapFromList(this.relationshipArray);
    this.relationshipJson = this.commonUtil.createNativeMapFromList(this.relationshipArray);

    this.workPartStatus = this.data.getValueFromSharedDataMap("WORKPARTSTATUS");
    this.workPartStatusMap = this.commonUtil.createMapFromList(this.workPartStatus);
    this.workPartStatusJson = this.commonUtil.createNativeMapFromList(this.workPartStatus);

    this.otherCharacteristics = this.data.getValueFromSharedDataMap("OTHERCHARACTERISTICS");
    this.otherCharacteristicsMap = this.commonUtil.createMapFromList(this.otherCharacteristics);
    this.otherCharacteristicsJson = this.commonUtil.createNativeMapFromList(this.otherCharacteristics);

    this.genderCds = this.data.getValueFromSharedDataMap("GENDER");
    this.genderMap = this.commonUtil.createMapFromList(this.genderCds);
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    this.gridOptions.api.hideOverlay();
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.hhSummaryList.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/household-summary/household-summary.component.ts